import { render, staticRenderFns } from "./GatesOfLoveList.vue?vue&type=template&id=e616a8e2&"
import script from "./GatesOfLoveList.vue?vue&type=script&lang=js&"
export * from "./GatesOfLoveList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports